import { render, staticRenderFns } from "./remnantOrder6.vue?vue&type=template&id=6f3d1e77&scoped=true&"
import script from "./remnantOrder6.vue?vue&type=script&lang=js&"
export * from "./remnantOrder6.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder6.vue?vue&type=style&index=0&id=6f3d1e77&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3d1e77",
  null
  
)

export default component.exports